/** Money is integer cents (NZD). Format for display. */
export function formatCents(cents: number): string {
  const sign = cents < 0 ? '-' : ''
  const abs = Math.abs(cents)
  return `${sign}$${(abs / 100).toFixed(2)}`
}

/** Zero replicates timestamps as epoch-ms numbers. */
export function formatTime(ms: number | null | undefined): string {
  if (ms == null) return ''
  return new Date(ms).toLocaleString('en-NZ', {
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
  })
}

/** Calendar-only fields are stored at UTC midnight and must not shift by locale. */
export function formatDate(ms: number | null | undefined): string {
  if (ms == null) return ''
  return new Date(ms).toLocaleDateString('en-NZ', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  })
}

/** Epoch-ms UTC midnight back to the `YYYY-MM-DD` an <input type="date"> wants. */
export function utcMsToDateInput(ms: number | null | undefined): string {
  if (ms == null) return ''
  return new Date(ms).toISOString().slice(0, 10)
}

export function relativeTime(ms: number | null | undefined): string {
  if (ms == null) return ''
  const diff = Date.now() - ms
  const sec = Math.round(diff / 1000)
  if (sec < 60) return `${sec}s ago`
  const min = Math.round(sec / 60)
  if (min < 60) return `${min}m ago`
  const hr = Math.round(min / 60)
  if (hr < 24) return `${hr}h ago`
  return formatTime(ms)
}
